import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-database-rule-action-component-advanced',
  templateUrl: './database-rule-action-component-advanced.component.html',
  styleUrls: ['./database-rule-action-component-advanced.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class DatabaseRuleActionComponentAdvancedComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  @Output()
  remove: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  addGroup: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  addCondition: EventEmitter<void> = new EventEmitter<void>();

  @Input() index: any;

  @Input() mainForm!: FormGroup;

  condition: any = [
    'AND', 'OR'
  ]

  addGroupMain(){

    if(this.mainForm.valid){
      this.addGroup.emit()
    }else{
      this.mainForm.markAllAsTouched();
    }
    
  }

  addConditionMain(){
    console.log(this.mainForm);
    
    if(this.mainForm.valid){
      this.addCondition.emit()
    }else{
      this.mainForm.markAllAsTouched();
    }
    
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}
